import axios from 'axios';

const appConfig = require('../config');

/**
 * 清空钉钉缓存
 * 根据生成的 app.js 哈希值判断首页是否更新
 * */

export default () => {
  const time = window.sessionStorage.getItem('time') || 0;
  let timer = null;
  let jsurl = '';
  for (const i of document.scripts) {
    if (i.src.includes('js/app.')) {
      jsurl = i.src;
    }
  }
  function getManifest() {
    axios
      .get(
        `${
          appConfig.publicPath
        }/manifest.json?version=${Date.now()}${Math.random()}`
      )
      .then(res => {
        if (!jsurl.includes(res.data['app.js']) && time < 3) {
          window.sessionStorage.setItem('time', time + 1);
          timer = setTimeout(() => location.reload(), 500);
        }
      })
      .catch(() => {
        window.sessionStorage.setItem('time', 3);
        if (timer) clearTimeout(timer);
      });
  }
  getManifest();
};
